import { IDocumentAttributes } from '@common/features/document/helpers';
import { enhanceWithHttps } from '@common/helpers';
import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { replaceTaskContent } from '@common/services/submissionService';
import { Id } from '@common/types';
import { usePleaseWaitOverlay } from '@components/PleaseWaitOverlay/usePleaseWaitOverlay';

interface IPostReplacementDocumentDetails {
  title: string;
  includeSecondaryDocument: boolean;
}

export const useReplaceDocument = (
  taskId: Id,
  replacementFileName: string,
  replacementOriginalFileName: string,
  replacementWeblink: string,
  replacementHtmlContent: string,
  includeSecondaryDocument: boolean,
  replacementOriginalSecondaryFileName: string,
  replacementSecondaryFileName: string,
  documentAttributes: IDocumentAttributes,
) => {
  const { handleShowOverlay, handleHideOverlay } = usePleaseWaitOverlay();

  const { mutate, data, isLoading } = useWaitingMutation(
    ({ title }: IPostReplacementDocumentDetails) => {
      const payload = {
        replacementFileName,
        replacementOriginalFileName,
        replacementHtmlContent,
        title,
        includeSecondaryDocument,
        replacementOriginalSecondaryFileName,
        replacementSecondaryFileName,
        ...(documentAttributes.shouldHandleCustomerLink
          ? { replacementCustomerLink: enhanceWithHttps(replacementWeblink) }
          : { replacementWeblink: enhanceWithHttps(replacementWeblink) }),
      };

      return replaceTaskContent(taskId, payload);
    },
    { onMutate: handleShowOverlay, onSuccess: handleHideOverlay, onError: handleHideOverlay },
  );

  return { replaceDocument: mutate, data, isLoading };
};
